
function initSequence()
{
  let canvasID = 'intro-sequence-canvas'
  let canvasHtml = $('#' + canvasID)
  let previewHtml = $('#intro-preview-image')
  let imageAmount = 20
  let imageName = 'CSDD'
  let imagesDirectory = canvasHtml.data('image-directory')
  let canvasWidth = parseInt(previewHtml.width())
  let canvasHeight = parseInt(previewHtml.height())


  const sequenceImages = []
  for (let i = 0; i <= imageAmount; i ++) {
    let img = new Image
    img.src = `${imagesDirectory}/${imageName}${`0${i}`.slice(-2)}.jpg`

    sequenceImages.push(img);
  }


  canvasHtml.attr('width', canvasWidth).attr('height', canvasHeight)
  let canvas = document.getElementById('intro-sequence-canvas');
  let context = canvas.getContext('2d');

  let setImage = function (newIndex) {
    if(sequenceImages[newIndex]) {
      context.drawImage(sequenceImages[newIndex], 0, 0, canvasWidth, canvasHeight);
    }

  }

  let currentImage = 0

  setTimeout(function (e){
    setInterval(function (e){
      setImage(currentImage)
      if(currentImage >= imageAmount) {
        currentImage = 0
      } else {
        currentImage += 1
      }
    }, 50)
  }, 1000)



}

export { initSequence }

